import { requestGet, requestPost } from '@/utils/request'

export function getMenuTree(params){
  return requestPost('/person/menu/getMenuTree', params);
}
export function getMenuList(params){
  return requestGet('/person/menu/list', params);
}
